<template>
  <div>
    <!-- ADDRESSES -->
    <div class="row">
      <div class="col-12">
        <b-card header="Company Addresses" header-tag="h4" body-class="mb-3 record_card_body">
          <div class="row">
            <div class="col-12">
              <datatable :type="'address'" :recordType="'company'" :rowData="addresses" :loadingMessage="addressLoadingMessage" :noRowsMessage="addressNoRowsMessage"
                         :columns="addressColumns" :heightStyle="heightStyle"></datatable>
            </div>
          </div>
        </b-card>
      </div>
      <div class="col-12">
        <b-card header="Company Contacts" header-tag="h4" body-class="mb-3 record_card_body">
          <div class="row">
            <div class="col-12">
              <datatable :type="'contacts'" :recordType="'company'" :rowData="contacts" :loadingMessage="contactLoadingMessage" :noRowsMessage="contactNoRowsMessage"
                         :columns="contactColumns" :heightStyle="heightStyle"></datatable>
            </div>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import Datatable from "datatables/datatable_not_full_height";

export default {
  name: "addresses_contacts",
  components: {Datatable},
  props: ['addresses', 'contacts'],
  data() {
    return {
      heightStyle: 'height: 400px !important',

      addressLoadingMessage: 'Loading Company Addresses...',
      addressNoRowsMessage: 'No Company Addresses Found',
      addressColumns: [
        {headerName: 'Type', field: 'address_type', minWidth: 175, pinned: 'left'},
        {headerName: 'Building', field: 'building', minWidth: 95},
        {headerName: 'Street', field: 'street', minWidth: 150},
        {headerName: 'Locality', field: 'locality', minWidth: 175},
        {headerName: 'City/Town', field: 'city_town', minWidth: 175},
        {headerName: 'County', field: 'county', minWidth: 175},
        {headerName: 'Postcode', field: 'postcode', minWidth: 175}
      ],
      contactLoadingMessage: 'Loading Company Contacts...',
      contactNoRowsMessage: 'No Company Contacts Found',
      contactColumns: [
        {headerName: 'Name', minWidth: 250, pinned: 'left', valueGetter: this.contact_name},
        {headerName: 'Job Title', minWidth: 95, valueGetter: this.contact_job_title},
        {headerName: 'Personal Mobile', minWidth: 150, valueGetter: this.contact_personal_mobile_value_getter},
        {headerName: 'Personal Landline', minWidth: 155, valueGetter: this.contact_personal_landline_value_getter},
        {headerName: 'Work Mobile', minWidth: 150, valueGetter: this.contact_work_mobile_value_getter},
        {headerName: 'Work Landline', minWidth: 155, valueGetter: this.contact_work_landline_value_getter},
        {headerName: 'Personal Email', minWidth: 250, valueGetter: this.contact_personal_email_value_getter},
        {headerName: 'Work Email', minWidth: 250, valueGetter: this.contact_work_email_value_getter}
      ],
    }
  },
  methods: {
    contact_name(params) {
      return params.data.person.first_name + ' ' + params.data.person.surname
    },
    contact_job_title(params) {
      if (params.data.rel_profile !== null && params.data.rel_profile.job_title !== null) {
        return params.data.rel_profile.job_title.job_title;
      }
    },
    contact_personal_mobile_value_getter(params) {
      return params.data.phones.personal_mobile;
    },
    contact_personal_landline_value_getter(params) {
      return params.data.phones.personal_landline;
    },
    contact_work_mobile_value_getter(params) {
      return params.data.phones.work_mobile;
    },
    contact_work_landline_value_getter(params) {
      return params.data.phones.work_landline;
    },
    contact_personal_email_value_getter(params) {
      return params.data.emails.personal_email;
    },
    contact_work_email_value_getter(params) {
      return params.data.emails.work_email;
    }
  }
}
</script>
